import React from "react";
import {
  formatAmount,
  formatDateWithSuffix,
  formatFullTimestamp,
} from "../../../utils/formatTime";
import { BsArrowLeft } from "react-icons/bs";
import CopyToClipboard from "../../../components/utils/CopyToClipboard";
interface EarningDetailsModalProps {
  onClose: () => void;
  earning: {
    points: number;
    cashAmount: number;
    status: string;
    updatedAt: string;
    createdAt: string;
    _id: string;
    bankDetails: {
      accountNumber: string;
      accountName: string;
      bankCode: string;
    };
  };
}

const EarningDetailsModal = ({
  onClose,
  earning,
}: EarningDetailsModalProps) => {
  const getStatusColor = (status: string) => {
    const s = (status ?? "").trim().toUpperCase();
    switch (s) {
      case "PENDING":
        return "text-[#CB9200] bg-[#CB9200]/20 p-2 rounded-lg";
      case "IN PROGRESS":
      case "IN_PROGRESS":
        return "text-[#60B7F6] bg-[#60B7F6]/10 p-2 rounded-lg";
      case "COMPLETED":
      case "APPROVED":
        return "text-[#03C668] bg-[#03C668]/10 p-2 rounded-lg";
      case "FAILED":
      case "REJECTED":
      case "DECLINED":
        return "text-red-700 bg-red-700/10 p-2 rounded-lg";
      default:
        return "text-gray-500 bg-gray-500/10 p-2 rounded-lg";
    }
  };

  return (
    <div className="fixed inset-0 font-sora flex justify-center items-start pt-16 overflow-auto pb-16 bg-black bg-opacity-75">
      <div className="bg-white dark:bg-[#1C2227] rounded-xl w-11/12 max-w-md relative">
        <div className="p-6">
          <div className="w-full flex justify-start gap-6 items-center">
            <button
              onClick={() => {
                onClose();
              }}
            >
              <BsArrowLeft className="text-black dark:text-white text-[20px]" />
            </button>
            <h4 className="text-gray-900 dark:text-gray-100 font-sora font-semibold text-[20px]">
              Earning Details
            </h4>
          </div>

          <div className="mt-8 space-y-6">
            <section>
              <h5 className="text-xs font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500 mb-3">
                Summary
              </h5>
              <div className="space-y-1">
                <div className="flex justify-between flex-col items-start gap-1 py-3 border-b border-gray-200 dark:border-gray-700">
                  <span className="text-gray-500 dark:text-gray-400 text-sm">
                    Points Redeemed
                  </span>
                  <span className="text-gray-900 dark:text-gray-100 font-semibold">
                    {earning.points} points
                  </span>
                </div>
                <div className="flex justify-between flex-col items-start gap-1 py-3 border-b border-gray-200 dark:border-gray-700">
                  <span className="text-gray-500 dark:text-gray-400 text-sm">
                    Cash Value
                  </span>
                  <span className="text-gray-900 dark:text-gray-100 font-semibold">
                    ₦ {formatAmount(earning.cashAmount)}
                  </span>
                </div>
                <div className="flex justify-between flex-col items-start gap-1 py-3 border-b border-gray-200 dark:border-gray-700">
                  <span className="text-gray-500 dark:text-gray-400 text-sm">
                    Bank Details
                  </span>
                  <span className="text-gray-900 dark:text-gray-100 font-semibold">
                    {earning.bankDetails?.accountNumber} -{" "}
                    {earning.bankDetails?.accountName}
                  </span>
                </div>
                <div className="flex justify-between flex-col items-start gap-1 py-3 border-b border-gray-200 dark:border-gray-700">
                  <span className="text-gray-500 dark:text-gray-400 text-sm">
                    Status
                  </span>
                  <span
                    className={`font-semibold text-[13px] ${getStatusColor(
                      earning.status
                    )}`}
                  >
                    {earning.status}
                  </span>
                </div>
              </div>
            </section>

            <section>
              <h5 className="text-xs font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500 mb-3">
                Details
              </h5>
              <div className="space-y-1">
                <div className="flex justify-between flex-col items-start gap-1 py-3 border-b border-gray-200 dark:border-gray-700">
                  <span className="text-gray-500 dark:text-gray-400 text-sm">
                    Transaction Date
                  </span>
                  <span className="text-gray-900 dark:text-gray-100 text-sm">
                    {formatDateWithSuffix(earning.createdAt)}
                  </span>
                </div>
                <div className="flex justify-between flex-col items-start gap-1 py-3 border-b border-gray-200 dark:border-gray-700">
                  <span className="text-gray-500 dark:text-gray-400 text-sm">
                    Date & time
                  </span>
                  <span className="text-gray-900 dark:text-gray-100 text-sm">
                    {formatFullTimestamp(earning.createdAt)}
                  </span>
                </div>
                <div className="flex justify-between flex-col items-start gap-1 py-3 border-b border-gray-200 dark:border-gray-700">
                  <span className="text-gray-500 dark:text-gray-400 text-sm">
                    Transaction ID
                  </span>
                  <CopyToClipboard text={earning._id}>
                    <span className="text-gray-900 dark:text-gray-100 text-sm font-mono">
                      {earning._id}
                    </span>
                  </CopyToClipboard>
                </div>
              </div>
            </section>
          </div>

          <button
            onClick={onClose}
            className="w-full mt-8 font-manrope bg-secondary_button text-white py-4 rounded-xl font-medium"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default EarningDetailsModal;
